import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { User } from '@/models/user.model';
import { Auth, LoginData, RegisterData } from '@/models/login.model';

class AuthService extends BaseService {
  private url: string = '/api';

  constructor() {
    super();
  }

  public async getCurrentUser(): Promise<DataResponse<User | null>> {
    const res = await this.$http.get<User>(`${this.url}/user/current`);

    return {
      status: res && [Status.Ok, Status.Created].includes(res.status),
      data: res && res.data?.id ? res.data : null,
    };
  }

  public async register(
    data: RegisterData,
  ): Promise<DataResponse<Auth | null>> {
    const res = await this.$http.post<Auth>(`${this.url}/user/register`, data);

    return {
      status: res && [Status.Ok, Status.Created].includes(res.status),
      data: res ? res.data : null,
    };
  }

  public async login(auth: LoginData): Promise<DataResponse<Auth | null>> {
    const res = await this.$http.post<Auth>(
      `${this.url}/user/login-admin`,
      auth,
    );

    return {
      status: res && [Status.Ok, Status.Created].includes(res.status),
      data: res ? res.data : null,
    };
  }

  public async logout(): Promise<MessageResponse> {
    const res = await this.$http.get<MessageData>(`${this.url}/user/logout`);
    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new AuthService();
